import React from "react";
import IPage from "../../interfaces/page"
import SalariesComponent from "../../components/Salaries/Salaries.component";

const SalariesPage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <SalariesComponent></SalariesComponent>;
};

export default SalariesPage;
